import {
  Edit,
  SimpleForm,
  TextInput,
  NumberInput,
  SelectInput,
  BooleanInput,
  DateTimeInput,
  ReferenceInput,
  AutocompleteInput,
  required,
} from 'react-admin';

const promoTypes = [
  { id: 'percentage', name: 'Процент' },
  { id: 'fixed_amount', name: 'Фиксированная сумма' },
];

const PromoCodeEdit = () => (
  <Edit>
    <SimpleForm>
      <TextInput source="id" disabled />
      <TextInput source="code" label="Код" validate={required()} />
      <SelectInput source="type" label="Тип" choices={promoTypes} validate={required()} />
      <NumberInput source="value" label="Значение" validate={required()} />
      
      <ReferenceInput 
        source="productId" 
        reference="products" 
        label="Продукт"
      >
        <AutocompleteInput 
          optionText="title" 
          validate={required()} 
          filterToQuery={(searchText: string) => ({ title: searchText })}
        />
      </ReferenceInput>
      
      <DateTimeInput 
        source="validFrom" 
        label="Действует с" 
        helperText="Оставьте пустым, чтобы промокод был активен сразу"
      />
      <DateTimeInput 
        source="validUntil" 
        label="Действует до" 
        helperText="Оставьте пустым для бессрочного действия"
      />
      
      <NumberInput source="maxUsageCount" label="Макс. количество использований" />
      <NumberInput source="currentUsageCount" label="Текущее количество использований" disabled />
      
      <BooleanInput source="isActive" label="Активен" />
    </SimpleForm>
  </Edit>
);

export default PromoCodeEdit;